export default "<mat-spinner></mat-spinner>"